module.exports = __webpack_public_path__ + "img/TrustServiceCategor6.1004df86.png";